import { isFeature } from 'Cloud/Application/FeaturesEs6';

export const disablePublicDownload = isFeature('disable-public-download');
